import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import GeographyService from "@app/geography/geographyService";
import { Unauthorized } from "@app/shared/ErrorPages";
import ErrorBoundary from "@app/shared/ErrorBoundary";
import { UserContext } from "@app/user/UserContext";
import { GeoLookupAddressView } from "@app/tools/GeoLookupAddressView";
import { GeoLookupCountyView } from "@app/tools/GeoLookupCountyView";
import GeoLookupState from "@app/tools/geoLookupState";
import { GeoLookupStateView } from "@app/tools/GeoLookupStateView";
import { GeoLookupZipView } from "@app/tools/GeoLookupZipView";

export default class GeoLookup extends React.Component<RouteComponentProps<{ context?: string, state?: string, ssa?: string, zip?: string }>, GeoLookupState> {
  private readonly geographyService = new GeographyService();

  constructor(props: RouteComponentProps<{ context?: string, state?: string, ssa?: string, zip?: string }>) {
    super(props);

    this.state = {
      states: [],
    };
  }

  public async componentDidMount() {
    if (String(this.props.match.params.context)) {
      const states = await this.geographyService.getStates();
      this.setState((prevState) => ({ ...prevState, states }));
    }
  }

  public render() {
    const context = String(this.props.match.params.context);
    if (context) {
      return (
        <UserContext.Consumer>
          {(user) => (
            user
              ? (
                <ErrorBoundary user={user}>
                  {this.renderGeoLookup(context)}
                </ErrorBoundary>)
              : (<Unauthorized />)
          )}
        </UserContext.Consumer>
      );
    } else {
      return null;
    }
  }

  private renderGeoLookup(
    context: string,
  ) {
    const haveAccess = true; //user.roles.indexOf(Roles.PREVIEW) > -1 ? true : false;

    if (haveAccess) {
      return this.renderActiveView(context);
    } else {
      //TODO: Maybe we can push '/' to the router at this point?
      return null;
    }
  }

  private handleCountyUrlPathChanged = (state: string, countySSA: string) => {
    this.props.history.push(`/tools/${String(this.props.match.params.context)}/${state}/${countySSA}`);
  }

  private renderActiveView(
    context: string,
  ): React.ReactNode {
    switch (context) {
      case "lookupstate":
        return <GeoLookupStateView states={this.state.states} />;
      case "lookupcounty":
        return <GeoLookupCountyView states={this.state.states} lookupState={String(this.props.match.params.state)} lookupCounty={String(this.props.match.params.ssa)} updateUrlPath={this.handleCountyUrlPathChanged} />;
      case "lookupzip":
        return <GeoLookupZipView lookupZip={String(this.props.match.params.zip)} />;
      case "lookupaddress":
        return <GeoLookupAddressView />;
      default:
        return <GeoLookupStateView states={this.state.states} />;
    }
  }
}
